import styled from '@emotion/styled';
import { Box } from '@mui/material';

export const SelectorsWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  margin-bottom: 24px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1rem;
`;

export const TranslationBoxWrapper = styled.div`
  border: 1px solid #d3d3d3;
  padding: 12px;
  border-radius: 4px;
  margin-bottom: 10px;
  width: 100%;
`;

export const TranslationLabel = styled.div`
  margin-bottom: 8px;
  font-size: 14px;
`;
